var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7625 1.18894L6.44327 5.84793C6.37995 5.90323 6.31135 5.9423 6.23747 5.96516C6.16359 5.98839 6.08443 6 6 6C5.91557 6 5.83641 5.98839 5.76253 5.96516C5.68865 5.9423 5.62005 5.90323 5.55673 5.84793L0.2216 1.18894C0.0738996 1.05991 0 0.89862 0 0.70507C0 0.51152 0.0792002 0.34562 0.2375 0.20737C0.3958 0.0691198 0.5805 0 0.7916 0C1.0026 0 1.1873 0.0691198 1.3456 0.20737L6 4.27189L10.6544 0.20737C10.8021 0.0783398 10.9841 0.0138202 11.2002 0.0138202C11.4168 0.0138202 11.6042 0.08295 11.7625 0.2212C11.9208 0.35945 12 0.52074 12 0.70507C12 0.8894 11.9208 1.05069 11.7625 1.18894Z",
    fill: "#285D69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    fill: "white",
    transform: "matrix(-1 0 0 -1 12 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.2167ed3da516e6ced370039de61766f2.svg";
export { ForwardRef as ReactComponent };